// extracted by mini-css-extract-plugin
export var clearFilter = "SearchForm-module--clearFilter--oEMtN";
export var filterContainer = "SearchForm-module--filterContainer--Tdo-H";
export var filterMulti = "SearchForm-module--filterMulti--I0iHY";
export var form = "SearchForm-module--form--qs5+k";
export var searchHitsLabel = "SearchForm-module--searchHitsLabel---TwqE";
export var sortContainer = "SearchForm-module--sortContainer--erGRP";
export var toggleButtonGroupLabel = "SearchForm-module--toggleButtonGroupLabel--p2qoe";
export var toggleButtonGroupWrapper = "SearchForm-module--toggleButtonGroupWrapper--QhvZ3";